import React, {InputHTMLAttributes, ReactElement} from "react";
import {omit} from "ramda";

interface FormInputProps {
    hasError?: boolean
}

export function FormInput(props: FormInputProps & InputHTMLAttributes<HTMLInputElement>): ReactElement {
    const hasError = props.hasError ?? false;
    const inputProps = omit(['className', 'hasError'], props);
    return (
        <input
            {...inputProps}
            className={`py-3 pl-4 pr-2 w-full
                        text-sm
                        rounded border border-gray-1 outline-0
                        focus:border-focus
                        ${hasError ? 'border-primary' : ''}`}
        />
    );
}